import React from 'react';

export const RichTextDataInputSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="10"
    height="9"
    viewBox="0 0 10 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.200894 4.99008L3.08053 7.93085C3.14366 7.99586 3.21878 8.04746 3.30154 8.08267C3.3843 8.11788 3.47307 8.13601 3.56273 8.13601C3.65238 8.13601 3.74115 8.11788 3.82392 8.08267C3.90668 8.04746 3.98179 7.99586 4.04493 7.93085C4.17142 7.8009 4.24242 7.62511 4.24242 7.44188C4.24242 7.25864 4.17142 7.08286 4.04493 6.95291L1.64071 4.49764L4.04493 2.04237C4.17142 1.91242 4.24242 1.73664 4.24242 1.5534C4.24242 1.37017 4.17142 1.19438 4.04493 1.06443C3.98147 1.00015 3.90621 0.949292 3.82346 0.914776C3.74071 0.88026 3.65211 0.862765 3.56273 0.863293C3.47335 0.862765 3.38474 0.88026 3.30199 0.914776C3.21925 0.949292 3.14399 1.00015 3.08053 1.06443L0.200894 4.0052C0.137237 4.06968 0.0867121 4.14639 0.0522321 4.23091C0.0177522 4.31543 0 4.40608 0 4.49764C0 4.5892 0.0177522 4.67986 0.0522321 4.76437C0.0867121 4.84889 0.137237 4.9256 0.200894 4.99008Z"
      fill="currentColor"
    />
    <path
      d="M4.24242 4.49964C4.24242 4.75068 4.03892 4.95419 3.78788 4.95419C3.53684 4.95419 3.33333 4.75068 3.33333 4.49964C3.33333 4.24861 3.53684 4.0451 3.78788 4.0451C4.03892 4.0451 4.24242 4.24861 4.24242 4.49964Z"
      fill="currentColor"
    />
    <path
      d="M6.66667 4.49964C6.66667 4.75068 6.46316 4.95419 6.21212 4.95419C5.96108 4.95419 5.75758 4.75068 5.75758 4.49964C5.75758 4.24861 5.96108 4.0451 6.21212 4.0451C6.46316 4.0451 6.66667 4.24861 6.66667 4.49964Z"
      fill="currentColor"
    />
    <path
      d="M5.45455 4.49964C5.45455 4.75068 5.25104 4.95419 5 4.95419C4.74896 4.95419 4.54545 4.75068 4.54545 4.49964C4.54545 4.24861 4.74896 4.0451 5 4.0451C5.25104 4.0451 5.45455 4.24861 5.45455 4.49964Z"
      fill="currentColor"
    />
    <path
      d="M9.79911 4.00921L6.91948 1.06844C6.85634 1.00343 6.78122 0.951834 6.69846 0.916622C6.6157 0.88141 6.52693 0.863281 6.43727 0.863281C6.34762 0.863281 6.25885 0.88141 6.17608 0.916622C6.09332 0.951834 6.01821 1.00343 5.95507 1.06844C5.82858 1.19839 5.75758 1.37418 5.75758 1.55741C5.75758 1.74065 5.82858 1.91643 5.95507 2.04638L8.35929 4.50165L5.95507 6.95692C5.82858 7.08687 5.75758 7.26265 5.75758 7.44589C5.75758 7.62912 5.82858 7.80491 5.95507 7.93486C6.01853 7.99914 6.09379 8.05 6.17654 8.08451C6.25929 8.11903 6.34789 8.13653 6.43727 8.136C6.52665 8.13653 6.61526 8.11903 6.69801 8.08451C6.78075 8.05 6.85601 7.99914 6.91948 7.93486L9.79911 4.99409C9.86276 4.92961 9.91329 4.8529 9.94777 4.76838C9.98225 4.68386 10 4.59321 10 4.50165C10 4.41009 9.98225 4.31943 9.94777 4.23492C9.91329 4.1504 9.86276 4.07369 9.79911 4.00921Z"
      fill="currentColor"
    />
  </svg>
);

export default RichTextDataInputSvg;
